"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnlessFeature = exports.IfFeature = exports.Features = exports.FeaturesContext = exports.appVersion = exports.HttpError = exports.ajax = void 0;

var ajaxObservables = _interopRequireWildcard(require("./ajaxObservables"));

var _appVersion = _interopRequireDefault(require("./appVersion"));

var features = _interopRequireWildcard(require("./Features"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ajax = ajaxObservables;
exports.ajax = ajax;
var HttpError = ajaxObservables.HttpError;
exports.HttpError = HttpError;
var appVersion = _appVersion["default"];
exports.appVersion = appVersion;
var FeaturesContext = features.FeaturesContext;
exports.FeaturesContext = FeaturesContext;
var Features = features.Features;
exports.Features = Features;
var IfFeature = features.IfFeature;
exports.IfFeature = IfFeature;
var UnlessFeature = features.UnlessFeature;
exports.UnlessFeature = UnlessFeature;